import React, { FC, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Layout } from 'antd'
import { useParams } from 'react-router-dom'

// reducers
import { getFormTemplate } from '../../reducers/form/formActions'

// utils
import { PAGE } from '../../utils/enums'

const { Content } = Layout

type Props = {
	page: PAGE
}

const PreviewPage: FC<Props> = (props) => {
	const { page } = props
	const { templateId } = useParams<{ templateId?: string }>()
	const dispatch = useDispatch()
	const [url, setUrl] = useState<string>('')

	useEffect(() => {
		;(async () => {
			try {
				let res: any = {}
				if (page !== PAGE.TEMPLATE_PREVIEW) {
					res = await dispatch(getFormTemplate(templateId))
				}
				const iframeUrl: string = res.data?.iframeUrl.split('?')?.[0]
				setUrl(`${iframeUrl}?queueID=${res.data?.queue?.name}`)
			} catch (err: any) {
				// eslint-disable-next-line no-console
				console.error(err.message)
			}
		})()
	}, [templateId, dispatch, page])

	return (
		<div>
			{page !== PAGE.TEMPLATE_PREVIEW && url !== '' && (
				<Content className={'preview-content'}>
					{/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
					<iframe src={`${url}&isPreview=true`} className={'preview-iframe w-full border-none'} />
				</Content>
			)}
		</div>
	)
}

export default PreviewPage
